export const { API_BASE } = process.env;
export const DISCORD_SERVER_INVITE = "https://discord.gg/QWw5vGt";
export const CROWDIN_PAGE = "https://crowdin.com/project/swarmbot";
export const DONATE_PAGE = "https://www.buymeacoffee.com/soya_daizu";
export const PER_PAGE = 5;
